import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import ProtectedRouteAdmin from "./components/ProtectedRouteAdmin";
import ProtectedRouteSiswa from "./components/ProtectedRouteSiswa";

// Halaman Umum
import Home from "./pages/Home";
import Pendaftaran from "./pages/Pendaftaran";
import PengumumanAgendaDetail from "./pages/PengumumanAgendaDetail";
import GuruDetail from "./pages/GuruDetail";
import Sejarah from "./pages/Sejarah";
import VisiMisi from "./pages/VisiMisi";
import KontakSekolah from "./components/KontakSekolah";
import GuruInfo from "./components/GuruInfo";
import PengumumanAgenda from "./components/PengumumanAgenda";
import BeritaList from "./components/BeritaList";
import BeritaDetail from "./components/BeritaDetail";
import Galeri from "./components/Galeri";
import PpdbInfo from "./components/PpdbInfo";
import Ekstrakurikuler from "./components/Ekstrakurikuler";
import Fasilitas from "./components/Fasilitas";

// Auth

import Login from "./pages/Login";
import DaftarAkun from "./pages/DaftarAkun";

// Dashboard
import AdminDashboard from "./pages/AdminDashboard";
import SiswaDashboard from "./pages/siswa/SiswaDashboard";
import StatusPendaftaran from "./pages/siswa/StatusPendaftaran";

// Admin CRUD
import ManageProfile from "./pages/admin/ManageProfile";
import ManageFasilitas from "./pages/admin/ManageFasilitas";
import ManageEkstrakurikuler from "./pages/admin/ManageEkstrakurikuler";
import ManageBerita from "./pages/admin/ManageBerita";
import ManageGaleri from "./pages/admin/ManageGaleri";
import ManageEvent from "./pages/admin/ManageEvent";
import ManageSlider from "./pages/admin/ManageSlider";
import ManageHomeHero from "./pages/admin/ManageHomeHero";
import ManagePengumumanAgenda from "./pages/admin/ManagePengumumanAgenda";
import ManageInformasiGuru from "./pages/admin/ManageInformasiGuru";
import ManagePrestasi from "./pages/admin/ManagePrestasi";
import ManagePPDB from "./pages/admin/ManagePPDB";
import ManageSejarah from "./pages/admin/ManageSejarah";
import ManageVisiMisi from "./pages/admin/ManageVisiMisi";
import ManageKontak from "./pages/admin/ManageKontak";
import ManagePendaftar from "./pages/admin/ManagePendaftar";
import ManageStatistikSekolah from "./pages/admin/ManageStatistikSekolah"; // ✅ TAMBAHAN

import "bootstrap/dist/css/bootstrap.min.css";
import "./styles.css";

// Utils
import { initPengumuman } from "./utils/initPengumuman";
import { initSlider } from "./utils/initSlider";

function App() {
  useEffect(() => {
    initPengumuman();
    initSlider();
  }, []);

  return (
    <BrowserRouter>
      <Navbar />

      <Routes>
        {/* ================= HALAMAN UMUM ================= */}
        <Route path="/" element={<Home />} />
        <Route path="/pendaftaran" element={<Pendaftaran />} />
        <Route path="/pengumumanagenda/:id" element={<PengumumanAgendaDetail />} />
        <Route path="/guru/:id" element={<GuruDetail />} />
        <Route path="/profil/sejarah" element={<Sejarah />} />
        <Route path="/profil/visi-misi" element={<VisiMisi />} />
        <Route path="/kontak-sekolah" element={<KontakSekolah />} />
        <Route path="/informasi-guru" element={<GuruInfo />} />
        <Route path="/informasi" element={<PengumumanAgenda />} />
        <Route path="/informasi/berita" element={<BeritaList />} />
        <Route path="/berita/:id" element={<BeritaDetail />} />
        <Route path="/informasi/galeri" element={<Galeri />} />
        <Route path="/ppdb/informasi" element={<PpdbInfo />} />
        <Route path="/profil/fasilitas" element={<Fasilitas />} />
        <Route path="/informasi/ekstrakurikuler" element={<Ekstrakurikuler />} />
        <Route path="/ppdb/status" element={<Login />}/>
        {/* ================= AUTH ================= */}
        <Route path="/login" element={<Login />} />
        <Route path="/daftar-akun" element={<DaftarAkun />} />

        {/* ================= SISWA ================= */}
        <Route
          path="/siswa"
          element={
            <ProtectedRouteSiswa>
              <SiswaDashboard />
            </ProtectedRouteSiswa>
          }
        />
        <Route
          path="/status-ppdb"
          element={
            <ProtectedRouteSiswa>
              <StatusPendaftaran />
            </ProtectedRouteSiswa>
          }
        />

        {/* ================= ADMIN ================= */}
        <Route
          path="/admin"
          element={
            <ProtectedRouteAdmin>
              <AdminDashboard />
            </ProtectedRouteAdmin>
          }
        />

        <Route path="/admin/manage-profile" element={<ProtectedRouteAdmin><ManageProfile /></ProtectedRouteAdmin>} />
        <Route path="/admin/sejarah" element={<ProtectedRouteAdmin><ManageSejarah /></ProtectedRouteAdmin>} />
        <Route path="/admin/visi-misi" element={<ProtectedRouteAdmin><ManageVisiMisi /></ProtectedRouteAdmin>} />
        <Route path="/admin/manage-fasilitas" element={<ProtectedRouteAdmin><ManageFasilitas /></ProtectedRouteAdmin>} />
        <Route path="/admin/manage-ekstrakurikuler" element={<ProtectedRouteAdmin><ManageEkstrakurikuler /></ProtectedRouteAdmin>} />
        <Route path="/admin/manage-kontak" element={<ProtectedRouteAdmin><ManageKontak /></ProtectedRouteAdmin>} />
        <Route path="/admin/manage-berita" element={<ProtectedRouteAdmin><ManageBerita /></ProtectedRouteAdmin>} />
        <Route path="/admin/manage-galeri" element={<ProtectedRouteAdmin><ManageGaleri /></ProtectedRouteAdmin>} />
        <Route path="/admin/manage-event" element={<ProtectedRouteAdmin><ManageEvent /></ProtectedRouteAdmin>} />
        <Route path="/admin/manage-slider" element={<ProtectedRouteAdmin><ManageSlider /></ProtectedRouteAdmin>} />
        <Route path="/admin/manage-home-hero" element={<ProtectedRouteAdmin><ManageHomeHero /></ProtectedRouteAdmin>} />
        <Route path="/admin/manage-pengumuman-agenda" element={<ProtectedRouteAdmin><ManagePengumumanAgenda /></ProtectedRouteAdmin>} />
        <Route path="/admin/manage-guru" element={<ProtectedRouteAdmin><ManageInformasiGuru /></ProtectedRouteAdmin>} />
        <Route path="/admin/manage-prestasi" element={<ProtectedRouteAdmin><ManagePrestasi /></ProtectedRouteAdmin>} />
        <Route path="/admin/manage-ppdb" element={<ProtectedRouteAdmin><ManagePPDB /></ProtectedRouteAdmin>} />
        <Route path="/admin/manage-pendaftar" element={<ProtectedRouteAdmin><ManagePendaftar /></ProtectedRouteAdmin>} />

        {/* ✅ ROUTE YANG KEMARIN ERROR */}
        <Route
          path="/admin/manage-statistik-sekolah"
          element={
            <ProtectedRouteAdmin>
              <ManageStatistikSekolah />
            </ProtectedRouteAdmin>
          }
        />

        {/* ================= FALLBACK ================= */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
